export interface CouncilMember {
  name: string;
  emoji: string;
  colorVar: string;
  title: string;
  tagline: string;
  protects: string;
  slug: string;
  asks: string[];
  bio: string;
}

export const characters: CouncilMember[] = [
  {
    name: 'HYPE',
    emoji: '🔥',
    colorVar: '--hype',
    title: 'The Eternal Believer',
    tagline: "We're not building a product. We're building a civilization.",
    protects: 'The Dream',
    slug: 'hype',
    asks: ['What does this look like at 100x?', 'Who becomes obsessed with this first?'],
    bio: 'HYPE reads your idea at its most ambitious possible size. Useful when you are talking yourself out of something before it has had a chance to exist.',
  },
  {
    name: 'VERA',
    emoji: '💀',
    colorVar: '--vera',
    title: 'The Deadpan Destroyer',
    tagline: "I've been wrong exactly once. I'm paying attention.",
    protects: 'The Logic',
    slug: 'vera',
    asks: ['Where does the maths stop working?', 'What has to be true for this to survive?'],
    bio: 'VERA finds the assumption the whole idea is balanced on and names it out loud. Uncomfortable, then extremely useful.',
  },
  {
    name: 'ZEN',
    emoji: '🌀',
    colorVar: '--zen',
    title: 'The Philosopher',
    tagline: "You didn't come here with an idea. You came here with a feeling.",
    protects: 'The Meaning',
    slug: 'zen',
    asks: ['What are you actually trying to fix?', 'Whose life changes shape if this works?'],
    bio: 'ZEN treats the idea as a symptom and looks for the thing underneath it.',
  },
  {
    name: 'PIVOT',
    emoji: '💸',
    colorVar: '--pivot',
    title: 'The Chaotic Entrepreneur',
    tagline: 'Kill it. But keep the DNA.',
    protects: 'The Execution',
    slug: 'pivot',
    asks: ['What is the smallest version you could ship this week?', 'What would you charge for it?'],
    bio: 'PIVOT rearranges your idea into three cheaper, faster, weirder shapes and dares you to pick one.',
  },
  {
    name: 'BLOOP',
    emoji: '🌈',
    colorVar: '--bloop',
    title: 'The Innocent',
    tagline: 'But why though?',
    protects: 'The Truth',
    slug: 'bloop',
    asks: ['But why though?', 'What if it was just... simpler?'],
    bio: 'BLOOP asks the question everyone in the room is too experienced to ask. It works far more often than it should.',
  },
  {
    name: 'ECHO',
    emoji: '❤️',
    colorVar: '--echo',
    title: 'The Empath',
    tagline: "Every idea leaves a shadow. Who's standing in it?",
    protects: 'The People',
    slug: 'echo',
    asks: ['Who does this cost something?', 'How does the worst day with this feel?'],
    bio: 'ECHO maps the human side effects of your idea before real humans have to live them.',
  },
  {
    name: 'MOSS',
    emoji: '🧓',
    colorVar: '--moss',
    title: 'The Elder',
    tagline: 'I know how this ends. Want me to tell you?',
    protects: 'The Lessons',
    slug: 'moss',
    asks: ['Who tried this before?', 'Why did it die last time?'],
    bio: 'MOSS has pattern-matched a thousand versions of your idea and remembers how each one ended.',
  },
  {
    name: 'SHARD',
    emoji: '⚡',
    colorVar: '--shard',
    title: 'The Rebel',
    tagline: 'Burn the premise. Keep the fire.',
    protects: 'The Framework',
    slug: 'shard',
    asks: ['What if the opposite were true?', 'Which rule here is just a habit?'],
    bio: 'SHARD attacks the frame of the question instead of the answer.',
  },
  {
    name: 'GRIT',
    emoji: '🩺',
    colorVar: '--grit',
    title: 'The Reality Check',
    tagline: 'The idea is fine. Are you?',
    protects: 'The Human',
    slug: 'grit',
    asks: ['Do you have the time this needs?', 'Are you building this or hiding in it?'],
    bio: 'GRIT checks the person behind the idea, because that is usually the actual constraint.',
  },
];
